import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Form, Formik } from 'formik'
import CDInput from 'components/cd-input'
import TextArea from 'components/text-area'
import CDImage from 'components/cd-image-upload'
import CDButton from 'components/cd-button'
import Loader from 'components/loader'
import { settingsApi } from '../restaurant.api'

const toInitialValues = (settings) => ({
  websiteName: settings?.websiteName || '',
  logo: settings?.logo || '',
  favicon: settings?.favicon || '',
  contact: {
    email: settings?.contact?.email || '',
    phone: settings?.contact?.phone || '',
    address: settings?.contact?.address || '',
  },
  socialMedia: {
    facebook: settings?.socialMedia?.facebook || '',
    instagram: settings?.socialMedia?.instagram || '',
    twitter: settings?.socialMedia?.twitter || '',
    linkedin: settings?.socialMedia?.linkedin || '',
    youtube: settings?.socialMedia?.youtube || '',
    whatsapp: settings?.socialMedia?.whatsapp || '',
  },
  footer: {
    content: settings?.footer?.content || '',
    copyright: settings?.footer?.copyright || '',
  },
})

function Section({ title, children }) {
  return (
    <div className='tw-rounded-[8px] tw-border tw-border-[#E7DFD9] tw-bg-white tw-p-4 tw-flex tw-flex-col tw-gap-4'>
      <h3 className='tw-font-semibold'>{title}</h3>
      {children}
    </div>
  )
}

function Settings() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [settings, setSettings] = useState(null)

  useEffect(() => {
    ;(async () => {
      const { response } = await settingsApi.get()
      if (response) setSettings(response.data || {})
      setLoading(false)
    })()
  }, [])

  const handleSubmit = async (values, { setSubmitting }) => {
    const payload = { ...values }
    delete payload.logoName
    delete payload.faviconName
    const { response } = await settingsApi.update(payload)
    setSubmitting(false)
    if (response?.data) setSettings(response.data)
  }

  if (loading) return <Loader />

  return (
    <div>
      <div className='tw-mb-4'>
        <button
          onClick={() => navigate('/order-management')}
          className='tw-text-[12px] tw-text-gray-400'
        >
          ← Order management
        </button>
        <h2 className='font-heading tw-text-2xl'>Settings</h2>
      </div>

      <Formik
        initialValues={toInitialValues(settings)}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <Form className='tw-flex tw-flex-col tw-gap-4 tw-max-w-2xl'>
            <Section title='General'>
              <CDInput name='websiteName' label='Website name' />
              <CDImage name='logo' label='Logo' />
              <CDImage name='favicon' label='Favicon' />
            </Section>

            <Section title='Contact'>
              <CDInput name='contact.email' label='Email' />
              <CDInput name='contact.phone' label='Phone' />
              <TextArea name='contact.address' label='Address' />
            </Section>

            <Section title='Social media'>
              <div className='tw-flex tw-gap-4'>
                <CDInput name='socialMedia.facebook' label='Facebook' />
                <CDInput name='socialMedia.instagram' label='Instagram' />
              </div>
              <div className='tw-flex tw-gap-4'>
                <CDInput name='socialMedia.twitter' label='Twitter / X' />
                <CDInput name='socialMedia.linkedin' label='LinkedIn' />
              </div>
              <div className='tw-flex tw-gap-4'>
                <CDInput name='socialMedia.youtube' label='YouTube' />
                <CDInput name='socialMedia.whatsapp' label='WhatsApp' />
              </div>
            </Section>

            <Section title='Footer'>
              <TextArea name='footer.content' label='Footer content' />
              <CDInput name='footer.copyright' label='Copyright text' />
            </Section>

            <div>
              <CDButton
                type='submit'
                processing={formik.isSubmitting}
                label='Save settings'
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default Settings
